export class ActivateResponse {
  constructor({ data, resultCode, resultDescription, traceId, jws, type }) {
    if (!resultCode) {
      throw new Error('Result code is required');
    }
    this.data = new DataToken(data);
    this.resultCode = resultCode;
    this.resultDescription = resultDescription;
    this.traceId = traceId;
    this.type = type;
    this.jws = jws;
  }
}

class DataToken {
  constructor({ identityLevel, processId, sessionToken, userId }) {
    if (!sessionToken) {
      throw new Error('Session Token is required');
    }
    this.identityLevel = identityLevel;
    this.processId = processId;
    this.sessionToken = sessionToken;
    this.userId = userId;
  }
}